import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    logList: []
  },
  getters: {
    logList: state => state.logList
  },
  mutations: {
    setLogList(state, payload) {
      state.logList = payload.slice();
    }
  },
  actions: {
    list({ commit }) {
      api.getLogList().then(({ data }) => {
        commit('setLogList', data);
      });
    }
  }
};

appStore.registerModule('logs', store);
